module.exports = __webpack_public_path__ + "img/Cornershop.c01eecf5.png";